import { render } from "./UserProfileAuditView.vue?vue&type=template&id=2ebfb68e&scoped=true"
import script from "./UserProfileAuditView.vue?vue&type=script&lang=js"
export * from "./UserProfileAuditView.vue?vue&type=script&lang=js"

import "./UserProfileAuditView.vue?vue&type=style&index=0&id=2ebfb68e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebfb68e"]])

export default __exports__